import React, { useState } from 'react';
import { FlatList, StyleSheet, View, TouchableOpacity, Image } from 'react-native';
import { Color } from '../../../styles';
import BaseText from '../../BaseText';

const SelfMessage = ({ item, onPress, style }) => (
  <TouchableOpacity onPress={onPress} style={[styles.self, style]}>
    <View style={styles.textSelfBack}>
      <BaseText style={[styles.text, { color: Color.accent }]}>{item.title}</BaseText>
    </View>
    <BaseText style={styles.textDown}>june 1, 2020 12:14p</BaseText>
  </TouchableOpacity>
);

const Message = ({ item, onPress, style }) => (
  <TouchableOpacity onPress={onPress} style={[styles.item, style]}>
    <Image
      source={{ uri: 'https://picsum.photos/100' }}
      style={{ width: 48, height: 48, borderRadius: 48 / 2, marginRight: 12 }}
    />
    <View style={{ flex: 1 }}>
      <View style={styles.textBack}>
        <BaseText style={styles.text}>{item.title}</BaseText>
      </View>
      <BaseText style={styles.textDown}>june 1, 2020 12:14p</BaseText>
    </View>
  </TouchableOpacity>
);

const Chat = ({ data }) => {
  const [selectedId, setSelectedId] = useState(null);
  const renderItem = ({ item }) => {
    if (item.self) {
      return <SelfMessage item={item} onPress={() => setSelectedId(item.id)} />;
    }
    return <Message item={item} onPress={() => setSelectedId(item.id)} />;
  };
  return (
    <FlatList
      data={data}
      contentContainerStyle={styles.contentContainerStyle}
      renderItem={renderItem}
      keyExtractor={(item) => item.id}
      extraData={selectedId}
      inverted={true}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  item: {
    flex: 1,
    padding: 12,
    flexDirection: 'row',
  },
  self: {
    flex: 1,
    padding: 12,
    alignItems: 'flex-end',
  },
  title: {
    fontSize: 32,
  },
  text: {
    paddingVertical: 6,
    paddingHorizontal: 12,
  },
  textBack: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.1)',
    width: '100%',
    borderRadius: 24,
    marginBottom: 6,
  },
  textSelfBack: {
    backgroundColor: Color.primary,
    width: '100%',
    borderRadius: 12,
    marginBottom: 6,
  },
  textDown: {
    color: Color.text.medium,
  },
  contentContainerStyle: {
    flexGrow: 1,
  },
});

export default Chat;
